import { LuPhone } from "react-icons/lu";
import { SlTag } from "react-icons/sl";
import { Link } from "react-router-dom";
import Footer from "../components/footer/Footer";
import Header from "../components/navbar/Header";
import { useState } from "react";
import CustomSlider from "../components/CustomSlider";
import serviceBanner from "../assets/mobile-banners/Gem_Web_Banners_Outlet.webp";
const servicemobileSlides = [
  {
    img: serviceBanner,
    alt: "Offer 1",
  },

];
// ---------------- FILTER BUTTON OPTIONS ----------------
const filterOptions = [
  { key: "all", label: "All" },
  { key: "arena", label: "Arena" },
  { key: "nexa", label: "Nexa" },
  { key: "truevalue", label: "True Value" },
  { key: "commercial", label: "Commercial" },
  { key: "suzuki", label: "Suzuki" },
  { key: "drivingschool", label: "Driving School" },
];

// ---------------- OUTLETS DATA (CLEAN TAGS) ----------------
export const outlets = [
  // ---------------- 4 WHEELER – ARENA ----------------
  {
    name: "Arena Sales Kondapur",
    tag: "arena",
    mapLink: `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15223.53892681349!2d78.36736187007533!3d17.46523031378365!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb92885f9f7cb3%3A0xa6232e27322df015!2sMaruti%20Suzuki%20ARENA%20(Gem%20Motors%2C%20Hyderabad%2C%20Kondapur)!5e0!3m2!1sen!2sca!4v1766436150228!5m2!1sen!2sca`,
    address:
      "Survey No, Opp:, KIMS Hospital, 64, Gachibowli - Miyapur Rd, Kondapur, Hanuman Nagar, Madhapur, kondapur, Hyderabad, Telangana 500084",
    phone: "9912349910",
  },
  {
    name: "Arena Sales & Service Chevella",
    tag: "arena",
    mapLink:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d238.0625965600458!2d78.1338261!3d17.3154746!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcbe8201fc6e681%3A0x54c40046f97a21b9!2sMaruti%20Suzuki%20ARENA%20(Gem%20Motors%2C%20Chevella)!5e0!3m2!1sen!2sca!4v1766436272357!5m2!1sen!2sca",
    address:
      "Survey No. 17/A, Opp Indian Oil Petrol Pump, Chevella, Telangana 501503",
    phone: "9912349910",
  },
  {
    name: "Arena Sales & Service Yennapally",
    tag: "arena",
    mapLink:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d294.7662394473809!2d77.9214896!3d17.3293158!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93cc8268e131%3A0xb3319b645c105bf0!2sMaruti%20Suzuki%20Service%20(Gem%20Motors)!5e1!3m2!1sen!2sca!4v1766436321862!5m2!1sen!2sca",
    address:
      "Yennapally, Hyderabad–Vikarabad Road, Vikarabad, Telangana 501101",
    phone: "9912349910",
  },
  {
    name: "Arena Sales & Service Moinabad",
    tag: "arena",
    mapLink:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d294.7438319559643!2d78.3232266!3d17.3432691!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcbeac9b50866cb%3A0x83d9a906b184950f!2sMaruti%20Suzuki%20ARENA%20(Gem%20Motors%2C%20Ranga%20Reddy%2C%20Moinabad)!5e1!3m2!1sen!2sca!4v1766436370880!5m2!1sen!2sca",
    address: "Himayat Sagar Rd, Aziznagar, Hyderabad, Telangana 500075",
    phone: "9912349910",
  },

  {
    name: "Arena Sales & Service Shabad",
    tag: "arena",
    mapLink:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d590.0826841995315!2d78.1330275!3d17.157111!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcbc5bc81a6336b%3A0x97d3a48b80b8b87d!2sMaruti%20Suzuki%20ARENA%20(Gem%20Motors%2C%20Ranga%20Reddy%2C%20Shabad)!5e1!3m2!1sen!2sca!4v1766436415310!5m2!1sen!2sca",
    address: "Survey No. 467/1, Shabad, Telangana 509217",
    phone: "9912349910",
  },

  {
    name: "Arena Service Kondapur",
    tag: "arena",
    mapLink:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d294.53949959561885!2d78.3586047!3d17.4700099!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb972d65079d43%3A0x54063ba57b47d12c!2sMpathy%20Digital%20Agency%20Pvt.%20Ltd.!5e1!3m2!1sen!2sca!4v1766436544892!5m2!1sen!2sca",
    address:
      "Raghavendra Society, Plot No. 506-B, Kondapur, Hyderabad, Telangana 500084",
    phone: "9912366672",
  },

  {
    name: "Arena Service Hydernagar",
    tag: "arena",
    mapLink:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1177.9635457428894!2d78.381343!3d17.5000321!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb921da6a59d43%3A0xc9ab2b518b1321c5!2sMaruti%20Suzuki%20Service%20(GEM%20Motors)!5e1!3m2!1sen!2sca!4v1766436577159!5m2!1sen!2sca",
    address:
      "Survey No.165, Hydernagar, Kukatpally, Hyderabad, Telangana 500085",
    phone: "9912342748",
  },

  {
    name: "Arena Service Manikonda",
    tag: "arena",
    mapLink:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4710.578760819168!2d78.35357957593486!3d17.54915359812333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb941ef1e91937%3A0x9889555f4631d92f!2sMaruti%20Suzuki%20Service%20(Gem%20Motors)!5e1!3m2!1sen!2sca!4v1766436687859!5m2!1sen!2sca",
    address:
      "Survey No.135/A, Manikonda, Shaikpet Main Rd, Hyderabad, Telangana 500089",
    phone: "9912347352",
  },
  {
    name: "Arena True Value Madhapur",
    tag: "truevalue",
    mapLink:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2356.542217403721!2d78.39439!3d17.4525234!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb91bd7f84f3a5%3A0x5e405a8be33a92ab!2sMaruti%20Suzuki%20TRUE%20VALUE%20(Gem%20Motors%2C%20Hyderabad%2C%20Madhapur)!5e1!3m2!1sen!2sca!4v1766436733190!5m2!1sen!2sca",
    address: "Mega Hills, Madhapur, Hyderabad, Telangana 500081",
    phone: "9912341360",
  },

  {
    name: "Arena True Value HyderNagar(kukatpally)",
    tag: "truevalue",
    mapLink:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d294.4912983860651!2d78.3816961!3d17.4997779!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb921db0310ee3%3A0xe1ecd6fc6dd78b3f!2sMaruti%20Suzuki%20TRUE%20VALUE%20(Gem%20Motors%2C%20Hyderabad%2C%20Kukatpally)!5e1!3m2!1sen!2sca!4v1766436774903!5m2!1sen!2sca",
    address:
      "9, Mumbai Highway Rd, Hyder Nagar, RamNaresh Nagar, Kukatpally, Hyderabad, Telangana 500085",
    phone: "9912341360",
  },

  // ---------------- COMMERCIAL ----------------
  {
    name: "GEM Commercial Bandlaguda",
    tag: "commercial",
    mapLink:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1178.8754174944843!2d78.3858603!3d17.35881!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb973dbd966961%3A0x61322bc4114022dd!2sMaruti%20Suzuki%20Commercial%20(Gem%20Motors%2C%20Hyderabad%2C%20Bandlaguda)!5e1!3m2!1sen!2sca!4v1766436824138!5m2!1sen!2sca",
    address:
      "Plot No 54 & 59, Survey No 20/A, Gandhamguda, Rajendranagar, Hyderabad, Telangana 500091",
    phone: "9912349910",
  },

  // ---------------- NEXA ----------------
  {
    name: "Nexa Sales Malakpet",
    tag: "nexa",
    mapLink:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d4715.232601672251!2d78.5162239!3d17.3692657!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9965a88a31dd%3A0xcb0cef2260de1aff!2sNEXA%20(Gem%20Motors%2C%20Hyderabad%2C%20Malakpet)!5e1!3m2!1sen!2sca!4v1766436861432!5m2!1sen!2sca",
    address:
      "H.No 16-2-741/C/8/2 & 3, Asmangadh Rd, Malakpet, Hyderabad, Telangana 500036",
    phone: " 90638 35543",
  },

  {
    name: "Nexa Service Kothapet",
    tag: "nexa",
    mapLink:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d294.70432610597464!2d78.5378762!3d17.3678432!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb99c1f3328a05%3A0xdef9f08903d5fdf2!2sMaruti%20Nexa!5e1!3m2!1sen!2sca!4v1766437128527!5m2!1sen!2sca",
    address: "NH 65, Opp Omini Hospital, Kothapet, Hyderabad, Telangana 500035",
    phone: "79976 00700",
  },

  // ---------------- DRIVING SCHOOL ----------------
  {
    name: "Driving School Moosapet",
    tag: "drivingschool",
    mapLink:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d294.5410467463149!2d78.416922!3d17.4690536!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb91e617df8daf%3A0x1a64c36875fabe0d!2sMaruti%20Suzuki%20Driving%20School%20(%20Gem%20Motors%2C%20Moosapet%20)!5e1!3m2!1sen!2sca!4v1766436916848!5m2!1sen!2sca",
    address:
      "Green Hills Rd, AGI Colony, Moosapet, Hyderabad, Telangana 500072",
    phone: "9912342657",
  },

  {
    name: "Driving School Suncity",
    tag: "drivingschool",
    mapLink:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1178.8754174944843!2d78.3858603!3d17.35881!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9765fd101ae5%3A0x9706a7a43ee9aec!2sGEM%20SUZUKI%20COMMERCIAL%20%26%20Maruti%20Driving%20School%20sun%20city%20Bandlaguda!5e1!3m2!1sen!2sca!4v1766436946423!5m2!1sen!2sca",
    address: "Westend Colony, Peeramcheru, Hyderabad, Telangana 500091",
    phone: "7036600600",
  },

  {
    name: "Driving School Madhapur",
    tag: "drivingschool",
    mapLink:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d589.1396360742066!2d78.3954091!3d17.4512607!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb915c16ab9287%3A0x1105c0e9a5f71e58!2sGEM%20Maruti%20Driving%20School%20Madhapur!5e1!3m2!1sen!2sca!4v1766436976497!5m2!1sen!2sca",
    address: "100 Feet Rd, Madhapur, Hyderabad, Telangana 500081",
    phone: "9133392333",
  },

  {
    name: "Driving School Kondapur",
    tag: "drivingschool",
    mapLink:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d589.0948996246552!2d78.3670412!3d17.4650953!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9337c4bd04b9%3A0x9123810fd9ef47e1!2sSuzuki%20Motorcycle%20(GEM%20Suzuki%2C%20Hyderabad%2C%20Kondapur%20Junction)!5e1!3m2!1sen!2sca!4v1766436998406!5m2!1sen!2sca",
    address: "Opp KIMS Hospital, Kondapur, Hyderabad, Telangana 500084",
    phone: "9912899138",
  },

  {
    name: "Driving School Manikonda",
    tag: "drivingschool",
    mapLink:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d294.648044747165!2d78.3803686!3d17.4027942!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb941ef72db493%3A0x6dc994f20da0f768!2sMaruti%20Driving%20school%20Manikonda!5e1!3m2!1sen!2sca!4v1766437030530!5m2!1sen!2sca",
    address: "Puppalaguda–Manikonda Main Rd, Hyderabad, Telangana 500089",
    phone: "7095100300",
  },
  {
    name: "Driving School Hydernagar",
    tag: "drivingschool",
    mapLink:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1177.9635457428894!2d78.381343!3d17.5000321!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb921da6a59d43%3A0xc9ab2b518b1321c5!2sMaruti%20Suzuki%20Service%20(GEM%20Motors)!5e1!3m2!1sen!2sca!4v1766437058059!5m2!1sen!2sca",
    address:
      "Plot No 2-11, Hydernagar, Kukatpally, Hyderabad, Telangana 500085",
    phone: "7997994909",
  },

  // ---------------- 2 WHEELER – SUZUKI ----------------
  {
    name: "Suzuki Motorcycle Kondapur",
    tag: "suzuki",
    mapLink:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d4712.757923736721!2d78.3646771!3d17.4651445!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9337c4bd04b9%3A0x9123810fd9ef47e1!2sSuzuki%20Motorcycle%20(GEM%20Suzuki%2C%20Hyderabad%2C%20Kondapur%20Junction)!5e1!3m2!1sen!2sca!4v1766437233511!5m2!1sen!2sca",
    address: "Kondapur, Hyderabad, Telangana",
    phone: "8071962820",
  },

  {
    name: "Suzuki Motorcycle Erragadda",
    tag: "suzuki",
    mapLink:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d589.1356826869684!2d78.4351335!3d17.4524837!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb90e0f977dd39%3A0x3951fe6b242677ef!2sSuzuki%20Motorcycle%20(Gem%20Suzuki%2C%20Hyderabad%2C%20Erragadda)!5e1!3m2!1sen!2sca!4v1766437278702!5m2!1sen!2sca",
    address: "Erragadda, Hyderabad, Telangana",
    phone: "8071962839",
  },

  {
    name: "Suzuki Motorcycle Krishna Nagar",
    tag: "suzuki",
    mapLink:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d4713.592213852433!2d78.4229802!3d17.4328779!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb912452b59f41%3A0xafd1039538e901a6!2sSuzuki%20Motorcycle%20(GEM%20Suzuki%2C%20Hyderabad%2C%20Krishna%20Nagar)!5e1!3m2!1sen!2sca!4v1766437321824!5m2!1sen!2sca",
    address: "Krishna Nagar, Hyderabad, Telangana",
    phone: "8071962829",
  },

  {
    name: "Suzuki Motorcycle Somajiguda",
    tag: "suzuki",
    mapLink:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4713.846291889443!2d78.4605752!3d17.4230398!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb974b4d065083%3A0xed0fe2f2f08e6904!2sSuzuki%20Motorcycle%20(GEM%20Suzuki%2C%20Hyderabad%2C%20Somajiguda)!5e1!3m2!1sen!2sca!4v1766437361108!5m2!1sen!2sca",
    address: "Somajiguda, Hyderabad, Telangana",
    phone: "8071962821",
  },

  {
    name: "Suzuki Motorcycle Madeenaguda",
    tag: "suzuki",
    mapLink:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4711.993169824854!2d78.3443691!3d17.494671099999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9266b2aada81%3A0xe3034f8998e0af3d!2sSuzuki%20Motorcycle%20(GEM%20Suzuki%2C%20Hyderabad%2C%20Madeenaguda)!5e1!3m2!1sen!2sca!4v1766437408542!5m2!1sen!2sca",
    address: "Madeenaguda, Hyderabad, Telangana",
    phone: "8071962840",
  },
];

// ---------------- COMPONENT ----------------
function Outlets() {
  const [activeFilter, setActiveFilter] = useState("all");
  const [searchValue, setSearchValue] = useState("");

  const filteredOutlets = outlets.filter((o) => {
    const matchesCategory = activeFilter === "all" || o.tag === activeFilter;
    const matchesSearch =
      o.name.toLowerCase().includes(searchValue.toLowerCase()) ||
      o.address.toLowerCase().includes(searchValue.toLowerCase());

    return matchesCategory && matchesSearch;
  });

  return (
    <>
      <Header />
      <div className="hidden md:block">
        <img
          src={require("../assets/Banners_Outlet.webp")}
          className="w-full 
              h-[250px]
              sm:h-[320px]
              md:h-[550px]
              lg:h-[550px]
              xl:h-[550px]
              object-cover  object-center"
          alt="outlets"
        />
      </div>
      <CustomSlider
        slides={servicemobileSlides}
        effect="fade"
        className="sm:hidden"
        imgClass="lg:mt-16"
      />
      {/* Breadcrumb */}
      <div className="px-4 shadow">
        <p className="container py-4 mx-auto">
          <Link to="/">Home</Link> / Outlets
        </p>
      </div>

      <div className="container px-5 py-16 mx-auto">
        <h4 className="mb-10 text-2xl font-semibold text-center">Outlets</h4>

        {/* Search */}
        <div className="flex justify-center mb-8">
          <input
            type="text"
            placeholder="Search by location or outlet name..."
            className="w-full px-4 py-3 border rounded-lg md:w-1/2"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </div>

        {/* Filters */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {filterOptions.map((f) => (
            <button
              key={f.key}
              onClick={() => setActiveFilter(f.key)}
              className={`px-5 py-2 rounded-full border ${activeFilter === f.key ? "bg-red-600 text-white" : "bg-white"
                }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {filteredOutlets.map((item, index) => (
            <div key={index} className="bg-white border shadow rounded-xl">
              <div className="p-5">
                <h5 className="font-semibold">{item.name}</h5>

                <span className="inline-block px-3 py-1 my-2 text-xs bg-indigo-100 rounded-full">
                  {item.tag}
                </span>

                <div className="space-y-2 text-sm">
                  <div className="flex gap-2">
                    <SlTag />
                    <p>{item.address}</p>
                  </div>

                  <div className="flex gap-2">
                    <LuPhone />
                    <a href={`tel:${item.phone}`}>{item.phone}</a>
                  </div>
                </div>

                <iframe
                  title={`${item.name} map`}
                  src={item.mapLink}
                  className="w-full h-40 border-0 rounded-lg"
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Outlets;
